import { createAction } from "@reduxjs/toolkit";
import {
  downloadCsvActionTypes,
  getCountersActionTypes,
  getDistributionsActionTypes,
  getIncomeActionTypes,
  getSalesActionTypes,
  getTransactionsActionTypes,
} from "./actionTypes";

export const getCounters = createAction(getCountersActionTypes.request);
export const getCountersSuccess = createAction(getCountersActionTypes.success);
export const getCountersFailure = createAction(getCountersActionTypes.failure);

export const getDistributions = createAction(
  getDistributionsActionTypes.request,
);
export const getDistributionsSuccess = createAction(
  getDistributionsActionTypes.success,
);
export const getDistributionsFailure = createAction(
  getDistributionsActionTypes.failure,
);

export const getSales = createAction(getSalesActionTypes.request);
export const getSalesSuccess = createAction(getSalesActionTypes.success);
export const getSalesFailure = createAction(getSalesActionTypes.failure);

export const getIncome = createAction(getIncomeActionTypes.request);
export const getIncomeSuccess = createAction(getIncomeActionTypes.success);
export const getIncomeFailure = createAction(getIncomeActionTypes.failure);

export const getTransactions = createAction(getTransactionsActionTypes.request);
export const getTransactionsSuccess = createAction(
  getTransactionsActionTypes.success,
);
export const getTransactionsFailure = createAction(
  getTransactionsActionTypes.failure,
);

export const downloadCsv = createAction(downloadCsvActionTypes.request);
